import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Grid, Header } from 'semantic-ui-react'

import * as styles from './styles'

class PageHeaderRow extends Component {
  static propTypes = {
    children: PropTypes.node,
    title: PropTypes.string.isRequired,
  }

  shouldComponentUpdate(nextProps, nextState) {
    return false
  }

  render() {
    const { children, title } = this.props

    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <Header as="h1">{title}</Header>
          {children && (
            <Header as="h5" style={styles.subHeader}>
              {children}
            </Header>
          )}
        </Grid.Column>
      </Grid.Row>
    )
  }
}

export default PageHeaderRow
